var io = require('../libs/socketio');

var pointOwners = new Map();
var ownerPoints = new Map();

function normalizePointRid(pointRid) {
  var value = String(pointRid || '');
  if (!value) return '';
  return value.charAt(0) === '#' ? value : '#' + value;
}

function subscribe(owner, pointRid) {
  var normalizedRid = normalizePointRid(pointRid);
  if (!owner || !normalizedRid) return;

  var points = ownerPoints.get(owner);
  if (!points) {
    points = new Set();
    ownerPoints.set(owner, points);
  }
  if (points.has(normalizedRid)) return normalizedRid;

  var owners = pointOwners.get(normalizedRid);
  var firstOwner = !owners || owners.size === 0;
  if (!owners) {
    owners = new Set();
    pointOwners.set(normalizedRid, owners);
  }
  points.add(normalizedRid);
  owners.add(owner);
  if (firstOwner) io.emit('subscribe', normalizedRid);
  return normalizedRid;
}

function renew(owner, pointRid) {
  var normalizedRid = normalizePointRid(pointRid);
  var points = ownerPoints.get(owner);
  if (!normalizedRid || !points || !points.has(normalizedRid)) return;
  io.emit('subscribe', normalizedRid);
}

function unsubscribe(owner, pointRid) {
  var normalizedRid = normalizePointRid(pointRid);
  var points = ownerPoints.get(owner);
  if (!normalizedRid || !points || !points.has(normalizedRid)) return;

  points.delete(normalizedRid);
  if (points.size === 0) ownerPoints.delete(owner);

  var owners = pointOwners.get(normalizedRid);
  if (!owners) return;
  owners.delete(owner);
  if (owners.size === 0) {
    pointOwners.delete(normalizedRid);
    io.emit('unsubscribe', normalizedRid);
  }
}

function release(owner) {
  var points = ownerPoints.get(owner);
  if (!points) return;
  Array.from(points).forEach(function (pointRid) {
    unsubscribe(owner, pointRid);
  });
}

function resubscribeActivePoints() {
  // Socket.IO rooms are connection-scoped. Restore all point rooms as soon as
  // the browser reconnects instead of waiting for the legacy renewal timer.
  pointOwners.forEach(function (owners, pointRid) {
    if (owners.size > 0) io.emit('subscribe', pointRid);
  });
}

io.on('connect', resubscribeActivePoints);

module.exports = {
  subscribe: subscribe,
  renew: renew,
  unsubscribe: unsubscribe,
  release: release,
  _test: {
    normalizePointRid: normalizePointRid,
    resubscribeActivePoints: resubscribeActivePoints
  }
};
